import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.storage;

const storageData = createSelector([selector], (state) => state);

export default {
  storageData
};
